module.exports = __webpack_public_path__ + "img/file-approval-survey-member.ccbb2d59.png";